import { render, staticRenderFns } from "./AppDeleteDialog.vue?vue&type=template&id=66b20fd5&"
import script from "./AppDeleteDialog.vue?vue&type=script&lang=js&"
export * from "./AppDeleteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports